// extracted by mini-css-extract-plugin
export default {"productGallery":"aQ-z","inQuickShop":"bQ-z"};